import { ViewEditModeContextProvider } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { RoomFormContainer } from '../Common/RoomFormContainer';

export const RoomCreation = () => {
  return (
    <ViewEditModeContextProvider>
      <RoomFormContainer />
    </ViewEditModeContextProvider>
  );
};
